export default {
    primaryColor: 'blue',
}